import {
  Add,
  ArrowDownwardTwoTone,
  ArrowUpwardTwoTone,
  Edit,
  EmailOutlined,
  Language,
  LocationOnOutlined,
  MyLocation,
  PeopleSharp,
  Person,
  Phone,
  School,
} from "@mui/icons-material";
import {
  useFetchProviderByIdMutation,
  useFetchProviderCareplansMutation,
  useFetchProviderCommunitiesMutation,
  useUpdateProviderMutation,
} from "../../../features/provider/providerApiSlice";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import FilterSelect from "../../../components/Filter/FilterSelect";
import Loading from "../../../components/Loading";
import React, { useEffect, useState } from "react";
import Search from "../../../components/Search/SearchNew";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import { Alert, Snackbar, Switch, Tooltip } from "@mui/material";
import classNames from "classnames";
import moment from "moment/moment";
import ProviderUpdate from "./components/ProviderUpdate";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/auth/authSlice";
import ProviderZoneEditModal from "./components/ProviderZoneEditModal";
import {
  ACTIVITY_STATUS,
  ACTIVITY_TYPE,
  GENDER,
} from "../../../constants/config.constants";
import ProviderPersonalInfoModal from "./components/ProviderPersonalInfoModal";
import ProviderContactInfoModal from "./components/ProviderContactInfoModal";
import ProviderQualificationUpdate from "./components/ProviderQualificationUpdate";
import { Trash2 } from "lucide-react";
import InfoModal from "../../../components/Modals/InfoModal";
import { useCreateLogsMutation } from "../../../features/logs/logsApiSlice";
import ProviderTypeUpdate from "./components/ProviderTypeUpdate";
import { styled } from "@mui/material/styles";
import ReusableModal from "../../../components/Modals/ReusableModal";
import { useFetchCareProgramsMutation, useFetchLobsMutation, useFetchPayersMutation } from "../../../features/criterion/criterionApiSlice";

const ProviderInfo = () => {

  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 40,
    height: 22,
    padding: 0,
    display: 'flex',
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(18px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: '#3b82f6', // blue ON
        },
      },
    },
    '& .MuiSwitch-thumb': {
      width: 18,
      height: 18,
      boxShadow: 'none',
    },
    '& .MuiSwitch-track': {
      borderRadius: 22 / 2,
      opacity: 1,
      backgroundColor: '#cbd5e1', // gray OFF
    },
  }));


  const user = useSelector(selectUser);
  const [patients, setPatients] = React.useState([]);
  const [communities, setCommunities] = React.useState([]);
  const [zones, setZones] = React.useState([]);
  const [locations, setLocations] = React.useState([]);
  const [statuses, setStatuses] = React.useState([]);
  const [provider, setProvider] = React.useState(null);

  const [statusFilter, setStatusFilter] = React.useState([]);
  const [locationFilter, setLocationFilter] = React.useState([]);
  const [searchFilter, setSearchFilter] = React.useState("");
  const [isEdit, setIsEdit] = React.useState(false);
  const [qualificationEdit, setQualificationEdit] = React.useState(false);
  const [qualificationEditData, setQualificationEditData] =
    React.useState(null);
  const [qualificationDeleteModal, setQualificationDeleteModal] =
    React.useState(false);

  const [sortStatusOrder, setSortStatusOrder] = React.useState("none");
  const [sortNameOrder, setSortNameOrder] = React.useState("none");

  const [sortNOPOrder, setSortNOPOrder] = React.useState("none");

  const [zoneEditModalOpen, setZoneEditModalOpen] = React.useState(false);
  const [openProviderTypeUpdate, setOpenProviderTypeUpdate] = React.useState(false);

  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState("Something went wrong");
  const [severity, setSeverity] = React.useState("error");

  const [tab, setTab] = React.useState("patients");

  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const marketId = searchParams.get("market");

  const handleTabChange = (newTab) => {
    if (newTab !== tab) {
      setTab(newTab);
    }
  };

  const handleSortStatus = (a, b) => {
    if (sortStatusOrder === "none") {
      return 0;
    } else if (sortStatusOrder === "asc") {
      return a.status.localeCompare(b.status);
    } else {
      return b.status.localeCompare(a.status);
    }
  };

  const handleSortName = (a, b) => {
    if (sortNameOrder === "none") {
      return 0;
    } else if (sortNameOrder === "asc") {
      return a.name.localeCompare(b.name);
    } else {
      return b.name.localeCompare(a.name);
    }
  };

  const handleSortNOP = (a, b) => {
    if (sortNOPOrder === "none") {
      return 0;
    } else if (sortNOPOrder === "asc") {
      return a.noOfPatients - b.noOfPatients;
    } else {
      return b.noOfPatients - a.noOfPatients;
    }
  };

  const navigate = useNavigate();

  const handleCommunityClick = (community) => {
    navigate(`/data-management/communities/${community.id}`);
  };

  const handlePatientClick = (patient) => {
    navigate(`/data-management/patients/${patient.patientId}`);
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleLocationFilter = (location) => {
    if (locationFilter.indexOf(location) === -1) {
      setLocationFilter([...locationFilter, location]);
    } else {
      setLocationFilter(locationFilter.filter((filter) => filter !== location));
    }
  };

  const handleStatusFilter = (status) => {
    if (statusFilter.indexOf(status) === -1) {
      setStatusFilter([...statusFilter, status]);
    } else {
      setStatusFilter(statusFilter.filter((filter) => filter !== status));
    }
  };

  const updateProviderZones = async (_locationId, zones) => {
    setZones(zones);
  };

  const [getPatients, { isLoading: patientsLoading }] =
    useFetchProviderCareplansMutation();

  const [getProviderById, { isLoading: providerLoading }] =
    useFetchProviderByIdMutation();

  const [getProviderCommunities, { isLoading: communitiesLoading }] =
    useFetchProviderCommunitiesMutation();

  const [updateProvider, { isLoading: updateProviderLoading }] =
    useUpdateProviderMutation();

  const [isConfirmMarketModalOpen, setIsConfirmMarketModalOpen] = React.useState(false);
  const [createLog] = useCreateLogsMutation();
  const [fetchLobs] = useFetchLobsMutation();
  const [fetchCarePrograms] = useFetchCareProgramsMutation();
  const [fetchPayers] = useFetchPayersMutation();
  
  const [lobs, setLobs] = useState([]);
  const [carePrograms, setCarePrograms] = useState([]);
  const [payers, setPayers] = useState([]);

  const isLoading =
    patientsLoading ||
    providerLoading ||
    communitiesLoading ||
    updateProviderLoading;

  const fetchPatients = async () => {
    try {
      const { data } = await getPatients({ id, marketId }).unwrap();

      setPatients(data);
      setLocations(
        Array.from(
          new Set(
            data.map((patient) =>
              patient.locationName === null
                ? "Private Residence"
                : patient.locationName
            )
          )
        )
      );
      setStatuses(Array.from(new Set(data.map((patient) => patient.status))));
    } catch (error) {
      console.error(error.data.message);
    }
  };

  const fetchCommunities = async () => {
    try {
      const { data } = await getProviderCommunities({ id, marketId }).unwrap();

      setCommunities(data);
    } catch (error) {
      console.error(error?.data?.message);
    }
  };

  const fetchProvider = async () => {
    try {
      const { data } = await getProviderById({ id, marketId }).unwrap();

      if (data?.zones && data?.zones?.length > 0) {
        setZones(data.zones);
      }

      setProvider(data);
    } catch (error) {
      console.error(error.data.message);
    }
  };

  useEffect(() => {
   const loadData = async () => {
    const lobsPromise = await fetchLobs({
      organisationId: user?.organisation?.id,
    }).unwrap()
    const careProgramsPromise = await fetchCarePrograms({
      organisationId: user?.organisation?.id,
    }).unwrap()
    const payersPromise = await fetchPayers({
      organisationId: user?.organisation?.id,
    }).unwrap()
    const [lobsData, careProgramsData, payersData] = await Promise.all([lobsPromise, careProgramsPromise, payersPromise])
    setLobs(lobsData?.data ?? []);
    setCarePrograms(careProgramsData?.data ?? []);
    setPayers(payersData?.data ?? []);
   }
   loadData()
  }, []);

  React.useEffect(() => {
    if (id) {
      fetchProvider();
      fetchPatients();
      fetchCommunities();
    }
  }, [id, marketId]);

  const Avatar = ({
    name,
    image,
    size = "w-10 h-10",
    textSize = "text-base",
    fontWeight = "font-normal",
  }) => {
    return (
      <>
        {image !== null ? (
          <div className="flex gap-2 items-center">
            <img
              src={image}
              alt={name}
              className={classNames(
                "object-cover w-10 h-10 rounded-full",
                size
              )}
            />
          </div>
        ) : (
          <p
            className={classNames(
              "flex justify-center items-center m-0 text-white rounded-full bg-primaryblue",
              size,
              textSize,
              fontWeight
            )}
          >
            {name
              .split(" ")
              .map((n) => n[0])
              .join("")}
          </p>
        )}
      </>
    );
  };

  const capitalize = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  const [personalInfoEditModal, setPersonalInfoEditModal] =
    React.useState(false);

  const [contactInfoEditModal, setContactInfoEditModal] = React.useState(false);

  const handleUpdateProvider = async () => {
    const payload = {
      activity: `Provider (${provider.name}) updated by User ${user?.details?.name}`,
      type: ACTIVITY_TYPE.PROVIDER_UPDATE,
      data: {
        providerId: provider.id,
      },
    };
    try {
      const filteredQualification = provider?.qualification?.filter(
        (q) => q.payer !== qualificationEditData.payer
      );
      const { data } = await updateProvider({
        ...provider,
        marketProfileId: marketId,
        qualification: filteredQualification,
        providerId: provider.id,
      }).unwrap();
      setProvider((prev) => ({ ...prev, ...data }));
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.SUCCESS,
      }).unwrap();
    } catch (error) {
      console.error(error?.data?.message);
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.FAILED,
      }).unwrap();
    }
  };

  const handleTogglePrimary = async (marketId) => {
    if (!provider?.market) return;

    try {
      // Call API to update primary market status
      const { data } = await updateProvider({
        providerId: id,
        marketProfileId: marketId,
        makePrimary: !provider.market.is_primary_market
      }).unwrap();

      // Update local state with new data
      setProvider(prev => ({
        ...prev,
        market: {
          ...prev.market,
          is_primary_market: !prev.market.is_primary_market
        }
      }));

    } catch (error) {
      showAlert(error?.data?.message, "error");
      console.error('Failed to update primary market:', error);
    }
  };
  const showAlert = (msg, severity) => {
    setOpen(true);
    setMessage(msg);
    setSeverity(severity);
  };

  return (
    <div className="flex flex-row items-start">
      <ReusableModal
        open={isConfirmMarketModalOpen}
        title={"Change Market Preference"}
        onClose={() => {
          setIsConfirmMarketModalOpen(false);
        }}
      >
        <div className="flex-col mx-4 my-2 d-flex">
          <div className="text-[15px] mt-1">
            Are you sure you want to set{" "}
            <span className="font-semibold">
              {provider?.market?.market_name}
            </span>{" "}
            as your{" "}
            <span className="font-semibold">
              {provider?.market?.is_primary_market ? "Secondary" : "Primary"} Market
            </span>
            ?
          </div>
          <div className="flex gap-2 justify-end pb-1 mt-4 w-full">
            <button
              onClick={() => {
                if (user?.permissions?.includes('providers_dm.edit_market_information')) {
                  handleTogglePrimary(provider?.market?.id)
                  setIsConfirmMarketModalOpen(false);
                }
              }}
              disabled={!user?.permissions?.includes('providers_dm.edit_market_information')}
              className="px-4 py-1 text-sm font-bold text-white rounded-md bg-primaryblue disabled:opacity-40 disabled:cursor-not-allowed w-fit h-fit"
            >
              Yes
            </button>
            <button
              onClick={() => {
                setIsConfirmMarketModalOpen(false);
              }}
              className="px-4 py-1 text-sm font-bold text-white rounded-md bg-primaryblue disabled:opacity-40 disabled:cursor-not-allowed w-fit h-fit"
            >
              No
            </button>
          </div>
        </div>
      </ReusableModal>
      <Snackbar
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={open}
        autoHideDuration={5000}
        message={message ? message : "Something went wrong"}
        severity="error"
      >
        <Alert
          onClose={() => setOpen(false)}
          severity={severity ? severity : "error"}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message ? message : "Something went wrong"}
        </Alert>
      </Snackbar>
      <Loading loading={isLoading} />
      <div className="py-4 pr-8 pl-16 w-4/12">
        <div className="w-full overflow-x-auto overflow-y-auto h-[calc(100vh-128px)] bg-white rounded-lg shadow border-1 border-primarygrayborder">
          <div className="flex flex-row justify-between items-center">
            <button className="p-3 text-primaryblue" onClick={handleBack}>
              Back
            </button>
          </div>
          <div className="flex flex-col gap-2 justify-end items-center p-4 border-b border-b-primarygrayborder">
            <div className="relative">
              <Avatar
                // name={provider?.name ?? ""}
                name={provider?.name?.replace(/\s*\(.*?\)\s*/g, '') ?? ""}
                image={null}
                size="w-20 h-20"
                textSize="text-3xl"
                fontWeight="font-semibold"
              />
              <div className="absolute right-0 bottom-14 w-4 h-4 rounded-full bg-primarygreen" />
            </div>
            {provider && (
              <p className="m-0 text-lg font-bold">
                {provider?.name}
              </p>
            )}
            {user?.permissions?.includes('providers_dm.view_type') && <p title="Provider Type" className="m-0 text-sm text-primarytextgrey">{provider?.type}</p>}
            <div className="flex flex-row gap-2 items-center">
              <p title="Provider Group" className="m-0 text-sm text-primarytextgrey">{
                provider?.provider_group_name ?? ''}</p>
              <span className="text-sm text-primarytextgrey">-</span>
              <p title="Speciality" className="m-0 text-sm text-primarytextgrey">{provider?.speciality ?? ''}</p>
            </div>
            {user?.permissions?.includes('providers_dm.view_type') && (
              <div className="flex flex-row gap-2 items-center">
                <span className="text-sm font-bold text-primarytextgrey">Type:</span>
                {user?.permissions?.includes('providers_dm.edit_type') ? (
                  <select
                    value={provider?.employment_type}
                    onChange={(e) => {
                      setProvider({ ...provider, employment_type: e.target.value });
                      setOpenProviderTypeUpdate(true);
                    }}
                    className="px-2 py-1 text-sm rounded border text-primarytextgrey border-gray"
                  >
                    <option value="Full-Time">Full-Time</option>
                    <option value="Per Diem">Per Diem</option>
                  </select>
                ) : (
                  <span className="text-sm text-primarytextgrey">{provider?.employment_type}</span>
                )}
              </div>
            )}
          </div>

          {/* <div className="flex flex-col gap-4 p-4 h-auto border-b border-b-primarygrayborder">

            <p className="m-0 text-lg font-bold">Market Information</p>
            <div
              className="flex justify-between items-start p-2 bg-blue-50 rounded cursor-pointer"
              style={{ border: "1px solid #3b82f6" }}
            >
              <div className="flex flex-col flex-1 gap-1">

                <div className="flex justify-between items-center mb-2">
                  <span className="text-sm font-semibold tracking-wide text-blue-600">
                    PRIMARY MARKET
                  </span>

                  <div className="flex gap-2 items-center">
                    <AntSwitch defaultChecked inputProps={{ 'aria-label': 'ant design' }} />
                    <span className="text-xs font-semibold">Primary</span>
                  </div>
                </div>
                <span className="text-xs font-semibold tracking-wide text-blue-800">
                  This is the provider's primary market
                </span>
                <span className="text-xs font-semibold tracking-wide text-gray-500">
                  Combined calendar view will default to EST timezone (UTC-5)
                </span>
              </div>
            </div>
          </div> */}
          {user?.permissions?.includes('providers_dm.view_market_information') && (
            <div className="flex flex-col gap-4 p-4 h-auto border-b border-b-primarygrayborder">
              <p className="m-0 text-lg font-bold">Market Information</p>

              {/* Check if provider has market object */}
              {provider?.market ? (
              // Provider has market object (multi-market provider)
              provider.market.is_primary_market ? (
                // PRIMARY MARKET = TRUE (Blue UI)
                <div
                  className="flex justify-between items-start p-2 bg-blue-50 rounded cursor-pointer"
                  style={{ border: "1px solid #3b82f6" }}
                >
                  <div className="flex flex-col flex-1 gap-1">
                    {/* Row: PRIMARY MARKET + Switch */}
                    <div className="flex justify-between items-center mb-2">
                      <span className="text-sm font-semibold tracking-wide text-blue-600">
                        PRIMARY MARKET
                      </span>

                      <div className="flex gap-2 items-center">
                        <AntSwitch
                          checked={true}
                          onChange={() => user?.permissions?.includes('providers_dm.edit_market_information') && handleTogglePrimary(provider.market.id)}
                          disabled={!user?.permissions?.includes('providers_dm.edit_market_information')}
                          inputProps={{ 'aria-label': 'primary market toggle' }}
                        />
                        <span className="text-xs font-semibold">Primary</span>
                      </div>
                    </div>
                    {/* Additional lines below */}
                    <span className="text-xs font-semibold tracking-wide text-blue-800">
                      This is the provider's primary market
                    </span>
                    <span className="text-xs font-semibold tracking-wide text-gray-500">
                      Combined calendar view will default to {provider.market.timezone || 'EST'} timezone
                    </span>
                  </div>
                </div>
              ) : (
                // PRIMARY MARKET = FALSE (Gray UI)
                <div
                  className="flex justify-between items-start p-2 bg-gray-50 rounded cursor-pointer"
                  style={{ border: "1px solid #d1d5db" }}
                >
                  <div className="flex flex-col flex-1 gap-1">
                    {/* Row: SECONDARY MARKET + Switch */}
                    <div className="flex justify-between items-center mb-2">
                      <span className="text-sm font-semibold tracking-wide text-gray-600">
                        SECONDARY MARKET
                      </span>

                      <div className="flex gap-2 items-center">
                        <AntSwitch
                          checked={false}
                          onChange={() => {
                            if (user?.permissions?.includes('providers_dm.edit_market_information')) {
                              setIsConfirmMarketModalOpen(true);
                            }
                          }}
                          disabled={!user?.permissions?.includes('providers_dm.edit_market_information')}
                          inputProps={{ 'aria-label': 'secondary market toggle' }}
                        />
                        <span className="text-xs font-semibold text-gray-500">Make Primary</span>
                      </div>
                    </div>

                    {/* Secondary market info */}
                    <span className="text-xs font-semibold tracking-wide text-gray-600">
                      Market: {provider.market.market_name}
                    </span>
                    <span className="text-xs font-semibold tracking-wide text-gray-500">
                      Timezone: {provider.market.timezone}
                    </span>
                    <div className="mt-1">
                      <span className="text-xs text-gray-500">• Toggle ON to make this the primary market</span>
                    </div>
                  </div>
                </div>
              )
            ) : (
              // NO MARKET OBJECT (Single market provider - show default UI)
              <div
                className="flex justify-between items-start p-2 bg-blue-50 rounded cursor-pointer"
                style={{ border: "1px solid #3b82f6" }}
              >
                <div className="flex flex-col flex-1 gap-1">
                  {/* Row: PRIMARY MARKET + Switch (disabled) */}
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-sm font-semibold tracking-wide text-blue-600">
                      PRIMARY MARKET
                    </span>

                    <div className="flex gap-2 items-center">
                      <AntSwitch
                        checked={true}
                        disabled
                        inputProps={{ 'aria-label': 'single market provider' }}
                      />
                      <span className="text-xs font-semibold">Primary</span>
                    </div>
                  </div>
                  {/* Additional lines below */}
                  <span className="text-xs font-semibold tracking-wide text-blue-800">
                    This is the provider's only market
                  </span>
                  <span className="text-xs font-semibold tracking-wide text-gray-500">
                    Single market provider - no other markets configured
                  </span>
                </div>
              </div>
            )}
            </div>
          )}
          <div className="flex flex-col gap-4 p-4 h-auto border-b border-b-primarygrayborder">
            <div className="flex justify-between items-center">
              <p className="m-0 text-lg font-bold">Contact Information</p>
              <button
                className="px-3 text-[#828282] disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={() => setContactInfoEditModal(true)}
                disabled={!user?.permissions?.includes('providers_dm.edit_email') && !user?.permissions?.includes('providers_dm.edit_phone')}
              >
                <Edit />
              </button>
            </div>
            {user?.permissions?.includes('providers_dm.view_email') && (
              <div className="flex gap-4 items-center">
                {provider && (
                  <Tooltip title="Email">
                    <div className="flex justify-center items-center w-10 h-10 bg-blue-50 rounded-md">
                      <EmailOutlined
                        style={{
                          color: "#828282",
                        }}
                      />
                    </div>
                  </Tooltip>
                )}
                <p className="m-0">{provider?.email}</p>
              </div>
            )}
            {user?.permissions?.includes('providers_dm.view_phone') && (
              <div className="flex gap-4 items-center">
                {provider && (
                  <Tooltip title="Phone Number">
                    <div className="flex justify-center items-center w-10 h-10 bg-blue-50 rounded-md">
                      <Phone
                        style={{
                          color: "#828282",
                        }}
                      />
                    </div>
                  </Tooltip>
                )}
                <p className="m-0">{provider?.phone}</p>
              </div>
            )}
          </div>
          <div className="flex flex-col gap-4 p-4 h-auto border-b border-b-primarygrayborder">
            <div className="flex justify-between items-center">
              <p className="m-0 text-lg font-bold">Personal Information</p>
              <button
                className="px-3 text-[#828282] disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={() => setPersonalInfoEditModal(true)}
                disabled={!user?.permissions?.includes('providers_dm.edit_address') && !user?.permissions?.includes('providers_dm.edit_gender')}
              >
                <Edit />
              </button>
            </div>
            {user?.permissions?.includes('providers_dm.view_address') && (
              <div className="flex gap-4 items-center">
                {provider && (
                  <Tooltip title="Home Address">
                    <div className="flex justify-center items-center h-10 bg-blue-50 rounded-md min-w-10">
                      <LocationOnOutlined
                        style={{
                          color: "#828282",
                        }}
                      />
                    </div>
                  </Tooltip>
                )}
                <p className="m-0">{provider?.address}</p>
              </div>
            )}
            {user?.permissions?.includes('providers_dm.view_gender') && (
              <div className="flex gap-4 items-center">
                {provider && (
                  <Tooltip title="Gender">
                    <div className="flex justify-center items-center w-10 h-10 rounded-md bg-subtleblue">
                      <Person
                        style={{
                          color: "#828282",
                        }}
                      />
                    </div>
                  </Tooltip>
                )}
                <p className="m-0">
                  {provider?.gender == null ? "NA" : GENDER[provider?.gender]}
                </p>
              </div>
            )}
          </div>
          <div className="flex flex-col gap-4 p-4 h-auto border-b border-b-primarygrayborder">
            <p className="m-0 text-lg font-bold">Service Information</p>
            <button
              onClick={() => handleTabChange("patients")}
              className="flex gap-4 items-center cursor-pointer"
            >
              <div
                className={classNames(
                  "flex items-center justify-center w-10 h-10 rounded-md",
                  tab === "patients" && "bg-subtleblue"
                )}
              >
                <PeopleSharp
                  style={{
                    color: tab === "patients" ? "#3062D4" : "#000",
                    fontSize: "20px",
                  }}
                />
              </div>
              <p
                className={classNames(
                  "m-0 font-semibold",
                  tab === "patients" && "text-primaryblue"
                )}
              >
                Patients ({patients.length})
              </p>
            </button>
            <button
              onClick={() => handleTabChange("communities")}
              className="flex gap-4 items-center cursor-pointer"
            >
              <div
                className={classNames(
                  "flex items-center justify-center w-10 h-10 rounded-md",
                  tab === "communities" && "bg-subtleblue"
                )}
              >
                <PeopleSharp
                  style={{
                    color: tab === "communities" ? "#3062D4" : "#000",
                    fontSize: "20px",
                  }}
                />
              </div>
              <p
                className={classNames(
                  "m-0 font-semibold",
                  tab === "communities" && "text-primaryblue"
                )}
              >
                Communities ({communities.length})
              </p>
            </button>
            <button
              className="flex gap-4 items-center"
              onClick={() => handleTabChange("qualification")}
            >
              <Tooltip title="Qualification / Skills">
                <div
                  className={classNames(
                    "flex items-center justify-center w-10 h-10 rounded-md",
                    tab === "qualification" && "bg-subtleblue"
                  )}
                >
                  <School
                    style={{
                      color: tab === "qualification" ? "#3062D4" : "#828282",
                    }}
                  />
                </div>
              </Tooltip>
              <p
                className={classNames(
                  "m-0 font-semibold",
                  tab === "qualification" && "text-primaryblue"
                )}
              >
                Qualification / Skills ({provider?.qualification?.length || 0})
              </p>
            </button>
          </div>
          <div className="flex flex-col gap-4 p-4 h-auto">
            <p className="m-0 text-lg font-bold">Additional Information</p>
            {user?.permissions?.includes('providers_dm.view_zips') && provider?.zip_codes?.length > 0 && <div className="flex gap-4 items-center">
                {provider && (
                  <Tooltip
                    // title="Zones"
                    title="Coverage"
                  >
                    <div className="flex justify-center items-center w-10 h-10 bg-blue-50 rounded-md">
                      <MyLocation
                        style={{
                          color: "#828282",
                          fontSize: "20px",
                        }}
                      />
                    </div>
                  </Tooltip>
                )}
                <div className="flex flex-row items-start">
                  <p className="m-0 max-h-[100px] overflow-auto">
                    {/* {zones.length > 0
                      ? `Default, ${zones.length > 2
                        ? `${zones
                          .slice(0, 2)
                          .map((zone) => zone.name)
                          .join(", ")} +${zones.length - 2} more`
                        : zones.map((zone) => zone.name).join(", ")
                      }`
                      
                      : "Default"} */}
                    {
                      provider?.zip_codes?.length > 0
                        ? provider?.zip_codes
                          .map((zip) => zip)
                          .join(", ") : ""
                    }
                  </p>
                  {/* <button
                    className="px-3 text-[#828282]"
                    onClick={() => setZoneEditModalOpen(true)}
                  >
                    <Edit />
                  </button> */}
                </div>
            </div>}
            <div className="flex gap-4 items-start">
                <Tooltip title="Primary & Secondary Language Preferences">
                  <div className="flex justify-center items-center w-10 h-10 rounded-md bg-subtleblue">
                    <Language
                      style={{
                        color: "#828282",
                      }}
                    />
                  </div>
                </Tooltip>
                <div className="flex flex-col">
                  <p className="m-0">
                    <span className="font-semibold">Primary Language:</span>{" "}
                    {provider?.languagePreference == null
                      ? "English"
                      : capitalize(provider.languagePreference)}
                  </p>
                  <p className="m-0 text-sm text-primarytextgrey">
                    <span className="font-semibold">Secondary Language:</span>{" "}
                    {provider?.secondaryLanguagePreference == null ||
                      provider?.secondaryLanguagePreference === ""
                      ? "None"
                      : provider.secondaryLanguagePreference
                        .split(",")
                        .map((language) => language)
                        .join(", ")}
                  </p>
                </div>
                <button
                  className="text-[#828282]"
                  onClick={() => setIsEdit(true)}
                  disabled={!user?.permissions?.includes('providers_dm.edit_language')}
                >
                  <Edit />
                </button>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-start py-4 w-8/12">
        <div className="flex flex-row gap-2 justify-between items-center pr-16 pl-8 w-full">
          <div className="flex flex-row gap-12 justify-between items-center w-full">
            <div className="flex flex-row gap-8 items-center w-full max-w-7xl">
              <Search value={searchFilter} setValue={setSearchFilter} />
              {tab !== "zones" && tab !== "qualification" && (
                <FilterSelect
                  value={locationFilter}
                  handleChange={handleLocationFilter}
                  data={locations}
                  placeholder="Filter by location..."
                />
              )}
              {tab !== "zones" && tab !== "qualification" && (
                <FilterSelect
                  value={statusFilter}
                  handleChange={handleStatusFilter}
                  data={statuses}
                  placeholder="Filter by Status ..."
                />
              )}
              {tab !== "zones" && tab !== "qualification" && (
                <button className="flex justify-center items-center px-4 py-2 text-sm font-bold text-white whitespace-nowrap rounded-lg opacity-30 cursor-not-allowed bg-primaryblue">
                  Export
                </button>
              )}
              {/* {tab === "zones" && tab !== "qualification" && (
                <button
                  onClick={() => {
                    setZoneEditModalOpen(true);
                  }}
                  className="px-4 py-2 shadow-sm rounded-md border-[2px] border-primarygrayborder whitespace-nowrap text-primaryblue"
                >
                  Edit Zones
                </button>
              )} */}
            </div>
            {tab === "qualification" && (
              <button
                onClick={() => {
                  setQualificationEdit(true);
                  setQualificationEditData(null);
                }}
                className="px-4 py-2 shadow-sm rounded-md border-[2px] border-primarygrayborder whitespace-nowrap text-primaryblue disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={!user?.permissions?.includes('providers_dm.edit_skills')}
              >
                Add
              </button>
            )}
          </div>
        </div>
        <div className="pr-16 pl-8 w-full">
          <div className="relative w-full mt-8 mb-2 overflow-x-auto overflow-y-auto bg-white rounded-lg shadow  max-h-[calc(100vh-200px)]">
            {tab === "patients" ? (
              <table className="relative w-full bg-white border-collapse table-auto whitespace-no-wrap table-striped">
                <thead>
                  <tr className="h-16 text-base font-bold text-left text-white whitespace-nowrap bg-primaryblue">
                    <th className="px-4 py-3">
                      <div className="flex flex-row gap-2 items-center">
                        <p className="m-0">Name</p>
                        <button
                          className="flex flex-col gap-1 items-center"
                          onClick={() => {
                            if (sortNameOrder === "none") {
                              setSortNameOrder("asc");
                            }
                            if (sortNameOrder === "asc") {
                              setSortNameOrder("desc");
                            }
                            if (sortNameOrder === "desc") {
                              setSortNameOrder("none");
                            }
                          }}
                        >
                          {sortNameOrder === "asc" ? (
                            <Tooltip title="Sort Descending">
                              <ArrowDownwardTwoTone />
                            </Tooltip>
                          ) : sortNameOrder === "desc" ? (
                            <Tooltip title="Sort Ascending">
                              <ArrowUpwardTwoTone />
                            </Tooltip>
                          ) : (
                            // <div className="flex items-center h-4">
                            //   <div className="w-6 h-[2px] bg-white" />
                            // </div>
                            <div className="flex items-center providerlist-icon">
                              <SwapVertIcon />
                            </div>
                          )}
                        </button>
                      </div>
                    </th>
                    <th className="px-4 py-3">Last Visit Date</th>
                    <th className="px-4 py-3">Date of Birth</th>
                    <th className="px-4 py-3">Gender</th>
                    <th className="px-4 py-3">EHR ID</th>
                    <th className="px-4 py-3">Location</th>
                    <th className="px-4 py-3">Coverage</th>
                    <th className="px-4 py-3">
                      <div className="flex flex-row gap-2 items-center">
                        <p className="m-0">Status</p>
                        <button
                          className="flex flex-col gap-1 items-center"
                          onClick={() => {
                            if (sortStatusOrder === "none") {
                              setSortStatusOrder("asc");
                            }
                            if (sortStatusOrder === "asc") {
                              setSortStatusOrder("desc");
                            }
                            if (sortStatusOrder === "desc") {
                              setSortStatusOrder("none");
                            }
                          }}
                        >
                          {sortStatusOrder === "asc" ? (
                            <Tooltip title="Sort Descending">
                              <ArrowDownwardTwoTone />
                            </Tooltip>
                          ) : sortStatusOrder === "desc" ? (
                            <Tooltip title="Sort Ascending">
                              <ArrowUpwardTwoTone />
                            </Tooltip>
                          ) : (
                            // <div className="flex items-center h-4">
                            //   <div className="w-6 h-[2px] bg-white" />
                            // </div>
                            <div className="flex items-center providerlist-icon">
                              <SwapVertIcon />
                            </div>
                          )}
                        </button>
                      </div>
                    </th>
                    {/* <th className="px-4 py-3">Edit</th> */}
                  </tr>
                </thead>
                <tbody>
                  {patients
                    .filter((patient) =>
                      patient.name
                        .toLowerCase()
                        .includes(searchFilter.toLowerCase())
                    )
                    .filter(
                      (patient) =>
                        statusFilter.length === 0 ||
                        statusFilter.indexOf(patient.status) !== -1
                    )
                    .filter(
                      (patient) =>
                        locationFilter.length === 0 ||
                        locationFilter.indexOf(
                          patient.locationName === null
                            ? "Private Residence"
                            : patient.locationName
                        ) !== -1
                    )
                    .sort((a, b) => handleSortName(a, b))
                    .sort((a, b) => handleSortStatus(a, b))
                    .map((patient, index) => (
                      <tr
                        className={classNames(
                          "text-left text-gray-900 h-24 whitespace-nowrap",
                          index !== patients.length - 1
                            ? "border-b"
                            : "border-none"
                        )}
                        key={index}
                      >
                        <td className="px-4 py-3 text-left">
                          <button
                            className="flex flex-row gap-4 items-center"
                            onClick={() => handlePatientClick(patient)}
                          >
                            <Avatar
                              name={patient.name}
                              image={null} />
                            <p className="m-0 font-semibold underline">
                              {patient.name}
                            </p>
                          </button>
                        </td>
                        <td className="px-4 py-3 text-left text-gray-700">
                          {patient.lvd
                            ? moment(patient.lvd).format("MM/DD/YYYY")
                            : "NA"}
                        </td>
                        <td className="px-4 py-3 text-left text-gray-700">
                          {patient.dob
                            ? moment(patient.dob).format("MM/DD/YYYY")
                            : "NA"}
                        </td>
                        <td className="px-4 py-3 text-left text-gray-700">
                          {patient.sex === "F" ? "Female" : "Male"}
                        </td>
                        <td className="px-4 py-3 text-left text-gray-700">
                          {patient.patientEhrId}
                        </td>
                        <td className="px-4 py-3 text-left text-gray-700">
                          {patient.locationName === null
                            ? "Private Residence"
                            : patient.locationName}
                        </td>
                        <td className="px-4 py-3 text-left text-gray-700">
                          {/* {patient.zones.length > 0
                            ? patient.zones.map((zone) => zone.name).join(", ")
                            : "NA"} */}

                          {patient?.zip}
                        </td>
                        <td className="px-4 py-3 text-left text-gray-700">
                          <div
                            className={classNames(
                              patient.status.toUpperCase() === "ACTIVE"
                                ? "bg-subtlegreen border-[1px] border-primarygreen text-primarygreen"
                                : "bg-primarylightgrey border-[1px] border-primarygrayborder text-primarytextgrey",
                              "rounded-md text-center flex flex-row gap-1 items-center px-2 w-fit"
                            )}
                          >
                            <div
                              className={classNames(
                                "w-2 h-2 rounded-full",
                                patient.status.toUpperCase() === "ACTIVE"
                                  ? "bg-primarygreen"
                                  : "bg-primarytextgrey"
                              )}
                            />
                            {patient.status}
                          </div>
                        </td>
                        {/* <td className="px-4 py-3 text-left">
                    <button
                      className="p-2 text-white rounded-md"
                      onClick={() => {}}
                    >
                      <IconComponent icon={"Edit_Icon"} i={provider.id} />
                    </button>
                  </td> */}
                      </tr>
                    ))}
                </tbody>
              </table>
            ) : tab === "communities" ? (
              <table className="relative w-full bg-white border-collapse table-auto whitespace-no-wrap table-striped">
                <thead>
                  <tr className="h-16 text-base font-bold text-left text-white whitespace-nowrap bg-primaryblue">
                    <th className="px-4 py-3">
                      <div className="flex flex-row gap-2 items-center">
                        <p className="m-0">Name</p>
                        <button
                          className="flex flex-col gap-1 items-center"
                          onClick={() => {
                            if (sortNameOrder === "none") {
                              setSortNameOrder("asc");
                            }
                            if (sortNameOrder === "asc") {
                              setSortNameOrder("desc");
                            }
                            if (sortNameOrder === "desc") {
                              setSortNameOrder("none");
                            }
                          }}
                        >
                          {sortNameOrder === "asc" ? (
                            <Tooltip title="Sort Descending">
                              <ArrowDownwardTwoTone />
                            </Tooltip>
                          ) : sortNameOrder === "desc" ? (
                            <Tooltip title="Sort Ascending">
                              <ArrowUpwardTwoTone />
                            </Tooltip>
                          ) : (
                            <div className="flex items-center h-4">
                              <div className="w-6 h-[2px] bg-white" />
                            </div>
                          )}
                        </button>
                      </div>
                    </th>
                    <th className="px-4 py-3">Address</th>
                    {/* <th className="px-4 py-3">
                      <div className="flex flex-row gap-2 items-center">
                        <p className="m-0">No of Patients</p>
                        <button
                          className="flex flex-col gap-1 items-center"
                          onClick={() => {
                            if (sortNOPOrder === "none") {
                              setSortNOPOrder("asc");
                            }
                            if (sortNOPOrder === "asc") {
                              setSortNOPOrder("desc");
                            }
                            if (sortNOPOrder === "desc") {
                              setSortNOPOrder("none");
                            }
                          }}
                        >
                          {sortNOPOrder === "asc" ? (
                            <ArrowDownwardTwoTone />
                          ) : sortNOPOrder === "desc" ? (
                            <ArrowUpwardTwoTone />
                          ) : (
                            <div className="flex items-center h-4">
                              <div className="w-6 h-[2px] bg-white" />
                            </div>
                          )}
                        </button>
                      </div>
                    </th> */}
                  </tr>
                </thead>
                <tbody>
                  {communities
                    .filter((community) =>
                      community.name
                        .toLowerCase()
                        .includes(searchFilter.toLowerCase())
                    )
                    .sort((a, b) => handleSortNOP(a, b))
                    .sort((a, b) => handleSortName(a, b))
                    .map((community, index) => (
                      <tr
                        className={classNames(
                          "text-left text-gray-900 h-24 whitespace-nowrap",
                          index !== communities.length - 1
                            ? "border-b"
                            : "border-none"
                        )}
                        key={index}
                      >
                        <td className="px-4 py-3 text-left">
                          <button
                            onClick={() => handleCommunityClick(community)}
                            className="flex flex-row gap-4 items-center"
                          >
                            <Avatar name={community.name} image={null} />
                            <p className="m-0 font-semibold underline">
                              {community.name}
                            </p>
                          </button>
                        </td>
                        <td className="px-4 py-3 text-left text-gray-700">
                          {community.address?.join(", ")}
                        </td>
                        {/* <td className="px-4 py-3 text-left text-gray-700">
                          {community.noOfPatients}
                        </td> */}
                      </tr>
                    ))}
                </tbody>
              </table>
            ) : tab === "zones" ? (
              <table className="relative w-full bg-white border-collapse table-auto whitespace-no-wrap table-striped">
                <thead>
                  <tr className="h-16 text-base font-bold text-left text-white whitespace-nowrap bg-primaryblue">
                    <th className="px-4 py-3">Name</th>
                  </tr>
                </thead>
                <tbody>
                  {zones.map((zone, index) => (
                    <tr key={index}>
                      <td className="px-4 py-3 text-left text-gray-700">
                        {zone.name}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : tab === "qualification" ? (
              <table className="relative w-full bg-white border-collapse table-auto whitespace-no-wrap table-striped">
                <thead>
                  <tr className="h-16 text-base font-bold text-left text-white whitespace-nowrap bg-primaryblue">
                    <th className="px-4 py-3">Payer</th>
                    <th className="px-4 py-3">LOB</th>
                    <th className="px-4 py-3">Program</th>
                    <th className="px-4 py-3">State</th>
                    <th className="px-4 py-3">Edit</th>
                    <th className="px-4 py-3">Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {provider?.qualification?.map((qualification, index) => (
                    <tr
                      className={classNames(
                        "text-left text-gray-900 h-24 whitespace-nowrap",
                        index !== provider?.qualification?.length - 1
                          ? "border-b"
                          : "border-none"
                      )}
                      key={qualification.payer}
                    >
                      <td className="px-4 py-3 text-left">
                        {qualification.payer}
                      </td>
                      <td className="px-4 py-3 text-left text-gray-700">
                        {qualification.lob
                          ? qualification.lob?.join(", ")
                          : "NA"}
                      </td>
                      <td className="px-4 py-3 text-left text-gray-700">
                        {qualification.program
                          ? qualification.program?.join(", ")
                          : "NA"}
                      </td>
                      <td className="px-4 py-3 text-left text-gray-700">
                        {qualification.state ? qualification.state : "NA"}
                      </td>
                      <td className="px-4 py-3 text-left">
                        <button
                          className="p-2rounded-md"
                          onClick={() => {
                            setQualificationEdit(true);
                            setQualificationEditData(qualification);
                          }}
                          disabled={!user?.permissions?.includes('providers_dm.edit_skills')}
                        >
                          <Edit />
                        </button>
                      </td>
                      <td className="px-4 py-3 text-left">
                        <button
                          className="p-2 rounded-md"
                          onClick={() => {
                            setQualificationDeleteModal(true);
                            setQualificationEditData(qualification);
                          }}
                          disabled={!user?.permissions?.includes('providers_dm.edit_skills')}
                        >
                          <Trash2 />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : null}
          </div>
        </div>
      </div>
      {isEdit && (
        <ProviderUpdate
          open={isEdit}
          setOpen={setIsEdit}
          data={provider}
          setData={setProvider}
        />
      )}
      {qualificationEdit && (
        <ProviderQualificationUpdate
          open={qualificationEdit}
          setOpen={setQualificationEdit}
          data={provider}
          setData={setProvider}
          edit={qualificationEditData}
          setEdit={setQualificationEditData}
          lobs={lobs}
          carePrograms={carePrograms}
          payers={payers}
          marketId={marketId}
        />
      )}
      {provider && (
        <ProviderZoneEditModal
          open={zoneEditModalOpen}
          setOpen={setZoneEditModalOpen}
          provider={provider}
          updateProviderZones={updateProviderZones}
        />
      )}
      {personalInfoEditModal && provider && (
        <ProviderPersonalInfoModal
          open={personalInfoEditModal}
          setOpen={setPersonalInfoEditModal}
          provider={provider}
          setProvider={setProvider}
          marketId={marketId}
        />
      )}
      {contactInfoEditModal && provider && (
        <ProviderContactInfoModal
          open={contactInfoEditModal}
          setOpen={setContactInfoEditModal}
          provider={provider}
          setProvider={setProvider}
        />
      )}
      {qualificationDeleteModal && (
        <InfoModal
          open={qualificationDeleteModal}
          setOpen={setQualificationDeleteModal}
          title="Delete Qualification"
          subtext="Are you sure you want to delete this qualification?"
          handleClose={() => {
            setQualificationDeleteModal(false);
            setQualificationEditData(null);
            handleUpdateProvider();
          }}
          primaryTitle="Delete"
          secondaryTitle="Cancel"
          secondaryClick={() => setQualificationDeleteModal(false)}
        />
      )}
      {openProviderTypeUpdate && (
        <ProviderTypeUpdate
          open={openProviderTypeUpdate}
          setOpen={setOpenProviderTypeUpdate}
          provider={provider}
          setProvider={setProvider}
        />
      )}
    </div>
  );
};

export default ProviderInfo;
